// src/utils/errorHandler.js
import { logger } from "../services/logger";

export const setupGlobalErrorHandling = () => {
  // Capturar errores globales
  const originalErrorHandler = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    logger.error(error || new Error(message), {
      component: "GlobalError",
      additionalData: {
        source,
        lineno,
        colno,
      },
    });

    if (originalErrorHandler) {
      return originalErrorHandler(message, source, lineno, colno, error);
    }

    return false;
  };

  // Capturar promesas rechazadas
  window.addEventListener("unhandledrejection", (event) => {
    event.preventDefault();
    logger.error(event.reason, {
      component: "UnhandledRejection",
    });
  });

  // Capturar errores de recursos
  window.addEventListener(
    "error",
    (event) => {
      if (
        event.target &&
        (event.target.tagName === "IMG" ||
          event.target.tagName === "SCRIPT" ||
          event.target.tagName === "LINK")
      ) {
        logger.error(
          new Error(
            `Resource loading error: ${event.target.src || event.target.href}`
          ),
          {
            component: "ResourceError",
            additionalData: {
              tagName: event.target.tagName,
              src: event.target.src || event.target.href,
            },
          }
        );
      }
    },
    true
  );
};
